import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import i18n from 'src/i18n';
import { Constants } from 'src/shared/constants';

// ----------------------------------------------------------------------


const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme, NAV_WIDTH }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: '0 40px 0 10px',
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav, headerTitle, open }) {
  const NAV_WIDTH = onOpenNav && 280;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  return (
    <StyledRoot NAV_WIDTH={NAV_WIDTH}>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>


        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: isMobile ? "100%" : !open ? 'calc(100% - 315px)' : "100%" }}
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          {headerTitle ?
            <Typography variant="h4" sx={{ color: Constants?.Black }}>
              {headerTitle}
            </Typography>
            : null}
          <Stack direction="row" alignItems="center" spacing={1}>
            {/* <LanguagePopover /> */}
            {/* <NotificationsPopover /> */}
            <Searchbar open />
            <AccountPopover />
          </Stack>
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
